import { useSelector } from '@legendapp/state/react';
import Modal from './Modal';
import TagPoolInput from './TagPoolInput';
import { 
  courseConfig$, 
  updateCourseConfig, 
  resetCourseConfig,
  COURSE_PRESETS 
} from '../store/courseConfig$';
import './CourseConfigModal.css';

/**
 * Modal for configuring course mode personalization settings
 * Settings are stored locally in localStorage
 */
export default function CourseConfigModal({ isOpen, onClose }) {
  // Subscribe to course config
  const config = useSelector(() => courseConfig$.get());

  const handleChange = (field) => (values) => {
    updateCourseConfig(field, values);
  };

  const handleReset = () => {
    resetCourseConfig();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Course Preferences">
      <div className="course-config-form">
        <TagPoolInput
          label="🧠 Learning Style"
          value={config.learningStyle}
          onChange={handleChange('learningStyle')}
          presets={COURSE_PRESETS.learningStyle}
          placeholder="Add custom style..."
        />

        <TagPoolInput
          label="🗣️ Communication Style"
          value={config.communicationStyle}
          onChange={handleChange('communicationStyle')}
          presets={COURSE_PRESETS.communicationStyle}
          placeholder="Add custom style..."
        />

        <TagPoolInput
          label="🌟 Tone Style"
          value={config.toneStyle}
          onChange={handleChange('toneStyle')}
          presets={COURSE_PRESETS.toneStyle}
          placeholder="Add custom tone..."
        />

        <TagPoolInput
          label="🔎 Reasoning Framework"
          value={config.reasoningFramework}
          onChange={handleChange('reasoningFramework')}
          presets={COURSE_PRESETS.reasoningFramework}
          placeholder="Add custom framework..."
        />

        <button 
          type="button" 
          className="course-config-reset-btn"
          onClick={handleReset}
        >
          Reset to Default
        </button>
      </div>
    </Modal>
  );
}

